





































































import mixins from 'vue-typed-mixins';
import DocumentsUtils, { Document } from '@/utils/DocumentsUtils';
import DocumentUpload from '@/components/documents/DocumentUpload.vue';
import { ReportContext, ReportNode, QuestionData } from '@/utils/ReportUtils';
import cloneDeep from 'lodash.clonedeep';
import { Question, SurveyParticipation } from '@/utils/SurveyUtils';

export default mixins().extend({
  props: {
    context: {
      type: Object as () => ReportContext,
    },
    node: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },
  },

  components: {
    DocumentUpload,
  },

  computed: {
    documents(): any {
      return {
        items: this.context.documents?.items,
        headers: [
          { text: this.$tc('model.document.name'), value: 'name' },
          {
            text: this.$tc('model.document.description'),
            value: 'description',
          },
          { text: this.$tc('model.document.uploaddate'), value: 'uploaddate' },
        ],
      };
    },

    associations(): any {
      return {
        items: this.context.documents?.items?.filter((document) =>
          document.associations
            ? document.associations?.findIndex(
                (association) => association.question?.id === this.node.item.id
              ) >= 0
            : false
        ),
        headers: [
          { text: this.$tc('model.document.name'), value: 'name' },
          {
            text: this.$tc('model.document.description'),
            value: 'description',
          },
          { text: this.$tc('model.document.uploaddate'), value: 'uploaddate' },
        ],
      };
    },
  },

  data(): {
    visible: boolean;
    selected: Document[];
    changes: Document[];
  } {
    return {
      visible: false,
      selected: [],
      changes: [],
    };
  },

  async mounted() {
    this.loadDocuments(true);
  },

  watch: {
    visible() {
      this.selected =
        this.context.documents?.items?.filter((document) =>
          document.associations?.some(
            (association) => association.question?.id === this.node.item.id
          )
        ) || [];
      this.changes = [];
    },

    'context.documents.options.showAllDocuments'() {
      this.loadDocuments(true);
    },
  },

  methods: {
    async loadDocuments(forceLoad?: boolean) {
      try {
        if (!this.context.documents?.items || forceLoad) {
          this.context.documents.items = undefined;
          let documents: Document[] = [];
          if (this.context.surveyParticipation) {
            documents = await DocumentsUtils.api.list({
              serviceproviderid: this.context.surveyParticipation
                .serviceprovider.id as number,
              surveyparticipationid: this.context.documents.options
                .showAllDocuments
                ? undefined
                : this.context.surveyParticipation?.id,
            });
          }
          if (!this.context.documents?.items) {
            this.context.documents.items = Array.from(documents);
          }

          this.reset();
        }
      } catch (error) {
        (this.$refs.alert as any).show('mounted', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    reset() {
      this.changes = [];
      this.selected =
        this.context.documents?.items?.filter((document) =>
          document.associations?.some(
            (association) => association.question?.id === this.node.item.id
          )
        ) || [];
    },

    async upload(document: Document) {
      if (this.context.documents?.items) {
        this.context.documents.items.push(document);
        this.context.documents.items = Array.from(this.context.documents.items);
      }

      const cloned = cloneDeep(document);
      cloned.associations = [
        {
          surveyparticipation: this.context
            .surveyParticipation as SurveyParticipation,
          question: this.node.item,
        },
      ];
      this.selected?.push(cloned);
      this.changes?.push(cloned);
    },

    async download(document: Document) {
      await DocumentsUtils.api.download([document]);
    },

    handleSelected(params: {
      item?: Document;
      items?: Document[];
      value: boolean;
    }) {
      const toggleAssociation = (document: Document, state: boolean) => {
        // look through the selected array as the passed document wont be up to date when this is called from the event handlers
        const item = cloneDeep(
          this.context.documents?.items?.find((item) => item.id === document.id)
        );

        if (item) {
          item.associations = item.associations || [];
          const associndex = item.associations?.findIndex(
            (association) => association.question?.id === this.node.item.id
          );
          if (associndex !== undefined && associndex >= 0 && !state) {
            item.associations?.splice(associndex, 1);
          } else if (!associndex || (associndex < 0 && state)) {
            item.associations?.push({
              surveyparticipation: this.context
                .surveyParticipation as SurveyParticipation,
              question: this.node.item,
            });
          }

          if (item.associations.length === 0) {
            item.associations = null;
          }

          const index = this.changes.findIndex((val) => item.id === val.id);
          if (index >= 0) {
            this.changes[index] = item;
          } else {
            this.changes.push(item);
          }
          this.changes = Array.from(this.changes);
        }
      };

      if (params.items) {
        for (const i in params.items) {
          toggleAssociation(params.items[i], params.value);
        }
      } else if (params.item) {
        toggleAssociation(params.item, params.value);
      }
    },

    async save() {
      try {
        const resp = await DocumentsUtils.api.update(
          this.changes,
          this.context.surveyParticipation as SurveyParticipation
        );
        if (this.context.documents?.items) {
          for (const i in resp) {
            const index = this.context.documents.items.findIndex(
              (document) => document.id === resp[i].id
            );
            if (index >= 0) {
              this.context.documents.items[index] = resp[i];
            }
          }
          this.context.documents.items = Array.from(
            this.context.documents.items
          );
        }
      } catch (error) {
        (this.$refs.alert as any).show('save', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }

      this.visible = false;
    },
  },
});
